<!-- Header row -->
<div class="chat-history-header d-flex justify-content-end align-items-center">
  <button
    class="delete-all-chats"
    title="Delete ALL Chats"
    [disabled]="chatSessions.length === 0 || (chatService.isLoading$ | async)"
    (click)="deleteAllChats($event)">
    DELETE ALL
  </button>
</div>

<!-- No chats message -->
<div *ngIf="chatSessions.length === 0" class="no-chats-msg text-center mt-3 px-3">
  No Chats yet. <br />
  Start a conversation to see it here!
</div>

<!-- Scrollable Container that retains scroll behavior -->
<div #scrollContainer
     class="chat-history-container"
     infiniteScroll
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="300"
     [scrollWindow]="false"
     [infiniteScrollContainer]="scrollContainer"
     (scrolled)="loadMore()">

  <ul class="chat-history-ul">
    <li
        *ngFor="let chat of chatSessions; trackBy: trackByChatId"
        class="chat-history-li"
        [ngClass]="{ 'active': chat.id === activeChatId }"
        title="{{ chat.display_name }}"
    >
      <div class="chat-item">
        <!-- Chat text that routes to the chat session -->
        <a [routerLink]="['/chat']" [queryParams]="{ chat_id: chat.id }" class="chat-link">
            {{ chat.display_name }}
        </a>
        <div class="dropdown">
          <button class="dropdown-toggle chat-menu-toggle" type="button" id="chatMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
            &middot; &middot; &middot;
          </button>
          <ul class="dropdown-menu" aria-labelledby="chatMenuButton">
            <!-- Normal option when not renaming -->
            <li *ngIf="renamingChatId !== chat.id">
              <button type="button" class="dropdown-item chat-menu-item rename-label" title="Rename Chat" (click)="openRenameChat(chat, $event)">
                Rename chat
              </button>
            </li>
            <!-- Inline rename form when in renaming mode -->
            <li *ngIf="renamingChatId === chat.id">
              <div class="dropdown-item rename-container" (click)="$event.stopPropagation()">
                <!-- A small label for context -->
                <div class="rename-label mb-1" title="">Rename chat</div>
                <div class="rename-input-row mb-2">
                  <input type="text" class="form-control" [(ngModel)]="renameInput" placeholder="Enter new Chat name" 
                         (click)="$event.stopPropagation()" />
                </div>
                <div class="rename-btns-row text-end">
                  <button type="button" class="rename-button" title="" (click)="saveRenameChat(chat, $event)">
                    Save
                  </button>
                  <button type="button" class="rename-button" title="" (click)="cancelRename($event)">
                    Cancel
                  </button>
                </div>
              </div>
            </li>
            <li>
              <button
                class="dropdown-item chat-menu-item delete-chat"
                title="Delete Chat"
                [disabled]="chatService.isLoading$ | async"
                (click)="deleteChat(chat, $event)">
                Delete chat
              </button>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
  <!-- <div *ngIf="loadingMore" class="loading-indicator">Loading...</div> -->
  <div *ngIf="allLoaded && chatSessions.length > 0" class="end-of-list text-center">End of Chat History</div>
</div>
